var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"personal-contact",attrs:{"data-testid":"personal-contact"}},[_c('PhoneForm',{attrs:{"user":_vm.user}}),_c('PersonalAddressForm',{attrs:{"user":_vm.user},on:{"validate-field":_vm.validateField}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }